<template lang="jade">
  .container-fluid
    .row
      .hdcp_main.col-md-12
        header.hdcp_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12.clearfix
            | I/O Status
        section.hdcp_content.col-lg-10.col-md-10.col-sm-11.col-xs-12.row_space--xs.col-centered.no_pad-xxs
          header.output.col-md-12.clearfix
            h2 Output
          section.output_section.col-md-12.col-lg-11.col-centered
            table.table.table-bordered.table-hover.table-striped.hdcp_table
              tr.title
                td.port
                  | Port
                td.link
                  | Link
                td.reconnect
                  | Reconnection
                td
                  | Debug Mode
              tr(v-for="(key, obj) in outputHDCP")
                td.port_key
                  | {{key}}
                td
                  indicator(v-bind:enable="outputLink[key]" na="true")
                td
                  button.btn.btn-info(v-on:click="resetLink(key, 'o')")
                    | Reconnect
                td
                  .iosCheck
                    .mask(v-on:click.stop="enterPassword(key)")
                    input(type='checkbox' v-bind:checked.sync="outputLink[key] && !outputHDCP[key].enabled " v-model="!outputHDCP[key].enabled")
                    i
          header.input_header.col-md-12.clearfix
            h2 Input
          section.input_section.col-md-12.col-lg-11.col-centered
            table.table.table-bordered.table-hover.table-striped.input_table
              tr.title
                td.port
                  | Port
                td.link
                  | Link
                td.reconnect
                  | Reconnection
                td
                  | HDCP&nbsp;&nbsp;
              tr(v-for="(key, obj) in inputLink")
                td
                  | {{key}}
                td
                  indicator(v-bind:enable="obj" na="true")
                td
                  button.btn.btn-info(v-on:click="resetLink(key, 'i')")
                    | Reconnect
                td
                  indicator(v-bind:enable="inputHDCP[key].enabled" na="true")


        modal(
          v-bind:show.sync="showModal"
          v-bind:close='cancel'
          v-bind:callback='applyChange'
          v-bind:backdrop='false'
          effect="fade"
          ok-text="Apply"
          cancel-text="Cancel"
          title="Enter Password")
          .modal-body.clearfix(slot="modal-body")
            .row
              .col-md-12
                .col-md-12
                  label
                    | Please enter the password to enable Debug mode:
                  input.form-control(v-model="password" type="password")
                .col-md-12
                  span.msg
                    | In order to get the device work properly, please turn off debug mode after finishing tests. Debug mode is&nbsp;
                    span.warning
                      | NOT&nbsp;
                    | recommended for normal usage.

</template>
<script>
import { call } from 'src/Service'
import { modal } from 'vue-strap'
import vSelect from 'src/components/Single-Select.vue'
import _ from 'lodash'
import Indicator from 'src/components/Indicator.vue'

export default {
  components: {
    Indicator,
    modal,
    'v-select': vSelect
  },
  data () {
    return {
      outputHDCP: {},
      outputLink: {},
      inputLink: {},
      inputHDCP: {},
      showModal: false,
      showEngineModal: false,
      password: '',
      HDCPEngine: '0.0',
      HDCPopts: [
        {label: '1.4', value: '1.4'},
        {label: '2.2', value: '2.2'}
      ],
      editting: ''
    }
  },
  asyncData () {
    let { mac } = this.$route.params

    call(mac, 'dxGetHDCP').then(({outputs, inputs}) => {
      console.log('HDCP outputs', outputs)
      console.log('HDCP inputs', inputs)
      this.outputHDCP = outputs
      this.inputHDCP = inputs
      if (this.$route.name === 'mixer') {
        return call(mac, 'dxGetMixerStatus')
      } else {
        return call(mac, 'dxGetMatrixStatus')
      }
    }).then(({links}) => {
      console.log('links', links)
      this.outputLink = links.outputs
      this.inputLink = links.inputs
    }).catch(err => {
      this.alert('danger', '', err)
    })
  },
  computed: {
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    enterPassword (key) {
      console.log(key)
      // let { mac } = this.$route.params
      this.editting = key
      if (this.outputHDCP[key].enabled) {
        this.showModal = true
      } else {
        this.applyChange()
      }
    },
    applyChange () {
      let { mac } = this.$route.params
      if (!this.outputHDCP[this.editting].enabled) {
        this.password = 'HDCP'
      }
      if (this.password !== 'HDCP') {
        return this.alert('danger', '', 'Invalid Password.')
      } else {
        let param = {
          enabled: !this.outputHDCP[this.editting].enabled,
          engine: this.HDCPEngine
        }
        console.log('HDCP param is: ', param)
        call(mac, 'dxSetHDCP', {
          outputs: {
            [this.editting]: param
          }
        }).then(res => {
          console.log(res)
          this.showModal = false
          this.password = ''
        }).catch(err => {
          this.alert('danger', '', err)
        })
      }
    },
    resetLink (key, which) {
      let { mac } = this.$route.params
      let ary = []
      let title = which === 'i' ? 'inputs' : 'outputs'
      ary[0] = key

      call(mac, 'dxResetLink', {
        [title]: ary
      }).then(res => {
        console.log(res)
      }).catch(err => {
        this.alert('danger', '', err)
      })
    }
  }, // close methods
  ready () {
  },
  watch: {
  },
  events: {
    update (mac, {type, event, msg}) {
      switch (type) {
        case 'hdcp':
          if (event.outputs && typeof event.outputs === 'object') {
            let newOut = _.cloneDeep(this.outputHDCP)
            _.assignIn(newOut, event.outputs)
            this.outputHDCP = _.cloneDeep(newOut)
          } else if (event.inputs && typeof event.inputs === 'object') {
            let newIn = _.cloneDeep(this.inputHDCP)
            _.assignIn(newIn, event.inputs)
            this.inputHDCP = _.cloneDeep(newIn)
          }
          break
        case 'links':
          console.log('got event links')
          if (event.outputs && typeof event.outputs === 'object') {
            let newOut = _.cloneDeep(this.outputLink)
            _.assignIn(newOut, event.outputs)
            console.log(newOut)
            this.outputLink = _.cloneDeep(newOut)
          }

          if (event.inputs && typeof event.inputs === 'object') {
            let newIn = _.cloneDeep(this.inputLink)
            _.assignIn(newIn, event.inputs)
            this.inputLink = _.cloneDeep(newIn)
          }

          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.hdcp_table, .input_table{
  text-align: center;
  & .port, & .link{
    width: 150px;
  }
  & .reconnect{
    width: 250px;
  }
  @include breakpoint(xxs) {
    .title {
      & .port, & .link{
        width:35px;
      }
      & .reconnect{
        width: 110px;
      }
    }
  }
}
.iosCheck{
  position: relative;
}
.mask{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height:100%;
  cursor:pointer;
}
.title{
  font-weight: bolder;
}
.port_key{
  padding-top:18px;
}
.msg{
  display: inline-block;
  display: inline-block;
  padding:7px;
  margin-top: 15px;
}
.warning{
  padding-left: 3px;
  margin-right: 5px;
  background-color: #f00;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// HDCP.vue?5a754cb1